export function checkPassword(password) {
    if (password.length < 8 || password.length > 16) {
        return false;
    }
    const hasLower = /[a-z]/.test(password);
    const hasUpper = /[A-Z]/.test(password);
    const hasDigit = /\d/.test(password);
    return hasLower && hasUpper && hasDigit;
}

export function toLocalDateTimString(utcDateTime) {
    if (!utcDateTime) {
        return "-"
    }
    return (new Date(utcDateTime)).toLocaleString(undefined,
        { year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            timeZoneName: 'short' });
}

export function floatToPercentage(num) {
    var percentage = (num * 100).toFixed(2);
    return percentage + "%";
}

export function array2dToString(array2d) {
    // 将二维数组转换为一个逗号分隔的字符串，并在每个子数组之间插入两个逗号
    return array2d.map(innerArray => innerArray.join(',')).join(',,');
}

export function sanitizeList(values) {
    return (values || [])
        .map((value) => (typeof value === 'string' ? value.trim() : value))
        .filter(Boolean);
}

export function stringToArray2d(str) {
    // 将字符串拆分为子数组字符串
    const subArrayStrings = str.split(',,');
    // 将每个子数组字符串转换为数组
    return subArrayStrings.map(subArrayString => subArrayString.split(',').map(String));
}

export function createReconnectingWebSocket({
                                                userId,
                                                getToken,
                                                onMessage,
                                                onOpen,
                                                onError,
                                                onClose,
                                                maxRetries = 5,
                                                retryDelay = 1000,         // 初始重连延迟（ms）
                                                heartbeatInterval = 30000, // 心跳间隔（ms）
                                            }) {
    if (!userId || !getToken) return null;

    const rawUrl = process.env[process.env.REACT_APP_ENV]?.url1?.replace(/^https?:\/\//, '');
    if (!rawUrl) {
        return null;
    }

    let ws = null;
    let retries = 0;
    let shouldReconnect = true;
    let heartbeatTimer = null;

    const connect = () => {
        const token = getToken();
        const wsUrl = `wss://${rawUrl}/ws/notify/user/${userId}?token=${encodeURIComponent(token)}`;
        ws = new WebSocket(wsUrl);

        ws.onopen = (event) => {
            retries = 0;
            onOpen && onOpen(event);

            // 启动心跳
            if (heartbeatInterval > 0) {
                heartbeatTimer = setInterval(() => {
                    if (ws && ws.readyState === WebSocket.OPEN) {
                        ws.send(JSON.stringify({ type: 'ping' }));
                    }
                }, heartbeatInterval);
            }
        };

        ws.onmessage = (event) => {
            try {
                const msg = JSON.parse(event.data);
                if (msg.type === 'pong') return; // 忽略心跳响应
            } catch (_) {
                // 忽略非 JSON
            }
            onMessage && onMessage(event);
        };

        ws.onerror = (err) => {
            onError && onError(err);
        };

        ws.onclose = (event) => {
            onClose && onClose(event);
            if (heartbeatTimer) {
                clearInterval(heartbeatTimer);
                heartbeatTimer = null;
            }
            if (shouldReconnect && retries < maxRetries) {
                const delay = retryDelay * Math.pow(2, retries);
                retries += 1;
                setTimeout(connect, delay);
            }
        };
    };

    connect();

    return {
        close: () => {
            shouldReconnect = false;
            if (heartbeatTimer) {
                clearInterval(heartbeatTimer);
            }
            ws && ws.close();
            // ❌ document.removeEventListener('visibilitychange', handleVisibilityChange);
        },
        getInstance: () => ws,
    };
}

let closeWebSocketFn = null;

export const setCloseWebSocket = (fn) => {
    closeWebSocketFn = fn;
};

export const closeWebSocket = () => {
    if (typeof closeWebSocketFn === 'function') {
        closeWebSocketFn();
    }
};
